module.exports = __webpack_public_path__ + "static/media/Grandmother - Charcoal.bd423391.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/img/Grandmother - Charcoal.jpg
 ** module id = 402
 ** module chunks = 0
 **/